



























































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlClearBtn from '@/components/common/control/CtrlClearBtn.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlResetBtn from '@/components/common/control/CtrlResetBtn.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import G_040_HatchuConfirm_Table from '@/components/G_kaigai/G_040_HatchuConfirm_Table.vue';
import G_040_HatchuConfirm_Rireki_Table from '@/components/G_kaigai/G_040_HatchuConfirm_Rireki_Table.vue';
import G_040_HatchuConfirm_ChildHeaderInput from '@/components/G_kaigai/G_040_HatchuConfirm_ChildHeaderInput.vue';
import G_040_HatchuEntry_RenrakuEntry from '@/components/G_kaigai/G_040_HatchuEntry_RenrakuEntry.vue';
import {
  OutStatus,
  MukoFlg,
  SumiFlg,
  KojoJotaiKb,
  GaibuRenkeiKinoId,
  ShoriKb,
} from '@/constants/constants';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { BUTTON } from '@/constants/label';
import { downloadCSVToSjis, dateStrToNum } from '@/utils/utils';
import {
  PageReport,
  FontDescriptor,
  FontStore,
} from '@grapecity/activereports/core';
import { PdfExport } from '@grapecity/activereports';
import '@/assets/scss/activeReportsJS/ar-js-ui.css';
import '@/assets/scss/activeReportsJS/ar-js-viewer.css';
import { Viewer } from '@grapecity/activereports-vue';

const headerExportCSV = [
  'データ連番',
  '支店コード',
  '支店名',
  '発注区分',
  '発注区分名',
  '受注日',
  '集荷先コード',
  '集荷先名',
  '受注№',
  '着日',
  '着情報',
  '出荷日',
  '得意先コード',
  '得意先名',
  '得意先住所１',
  '得意先住所２',
  '得意先住所３',
  '納品先コード',
  '納品先名',
  '納品先住所１',
  '納品先住所２',
  '入力支店コード',
  '入力支店名',
  '品目コード',
  '年産',
  '品名',
  '数量',
  '端数',
  'サイン',
  '入庫名義',
  '発注備考',
  '明細備考',
  '客先伝票№',
  'オーダー№',
  '事故区分',
  '事故名称',
  '受注明細Ｎｏ',
  '修正回数',
  '削除',
  '訂正前集荷先名',
  '訂正前着日',
  '訂正前出荷日',
  '訂正前数量',
  '訂正前得意先コード',
  '訂正前得意先名',
  '訂正前納品先コード',
  '訂正前納品先名',
  '取込用取引先コード',
  '取込用納入先コード',
];

function getRow(item: any) {
  return [
    item.dataNo,
    item.shitenCd,
    item.shitenMei,
    item.hatchuKb,
    item.hatchuKbMei,
    dateStrToNum(item.juchuYmd),
    item.shukasakiCd,
    item.shukasakiMei,
    item.juchuNo,
    dateStrToNum(item.chakuYmd),
    item.chakuInfo,
    dateStrToNum(item.shukkaYmd),
    item.tokuisakiCd,
    item.tokuisakiMei,
    item.tokuisakiAddress1,
    item.tokuisakiAddress2,
    item.tokuisakiAddress3,
    item.nohinsakiCd,
    item.nohinsakiMei,
    item.nohinsakiAddress1,
    item.nohinsakiAddress2,
    item.entryShitenCd,
    item.entryShitenMei,
    item.himmokuCd,
    item.nensan,
    item.himmokuMei,
    item.suryo,
    item.hasu,
    item.sign,
    item.nyukoMeigi,
    item.seikyuBiko,
    item.meisaiBiko,
    item.kyakusakiDenpyoNo,
    item.orderNo,
    item.jikoKb,
    item.jikoMei,
    item.juchuMeisaiNo,
    item.shuseiCount,
    item.del,
    item.teiseiShukasakiMei,
    dateStrToNum(item.teiseiChakuYmd),
    dateStrToNum(item.teiseiShukkaYmd),
    item.teiseiSuryo,
    item.teiseiTokuisakiCd,
    item.teiseiTokuisakiMei,
    item.teiseiNohinsakiCd,
    item.teiseiNohinsakiMei,
    item.impTorihikiCd,
    item.impNonyuCd,
  ];
}

export default Vue.extend<any, any, any, any>({
  name: 'G_040_HatchuConfirm',
  components: {
    CtrlMessageDialog,
    CtrlDatePicker,
    CtrlResetBtn,
    CtrlClearBtn,
    CtrlNormalBtn,
    G_040_HatchuConfirm_Table,
    G_040_HatchuConfirm_Rireki_Table,
    G_040_HatchuConfirm_ChildHeaderInput,
    G_040_HatchuEntry_RenrakuEntry,
    Viewer,
  },
  data: () => ({
    BUTTON,
    juchuYmdF: '',
    juchuYmdT: '',
    entryJigyoshoCd: 0,
    nyukoJigyoshoCd: 0,
    search: '',
    items: [],
    selected: [],
    kakuninFlg: false,
    childHeaderInputItem: {},
    childHeaderInputShow: false,
    batchOrderEditingShow: false,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    messageConfirmSubmit: false,
    isReload: false,
    ShoriKb,
    shoriKb: ShoriKb.REFER,
    childRirekiItem: {},
    childRirekiShow: false,
    loadErr: false,
    childShowRenrakuEntry: false,
    childRenrakuItem: {},
    exportDialogShow: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    itemsHatchuConfirm() {
      if (this.$store.state['g040'].list == null) {
        return [];
      } else {
        return this.kakuninFlg
          ? this.$store.state['g040'].list
          : this.$store.state['g040'].list.filter(
              (item: any) => item.motoMukoFlg == MukoFlg.MUKO
                            || (item.mukoFlg == MukoFlg.YUKO
                                && item.kakuninFlg == SumiFlg.MI 
                               ) 
            );
      }
    },
  },
  methods: {
    handleGetFilteredItems(e: any) {
      this.filteredItems = e;
    },
    async handleReset() {
      if (await this.checkValidate()) {
        this.$store.dispatch('g040/resetData');
        this.selected = [];
        this.getData();
      }
    },
    handleClear() {
      this.juchuYmdF = moment(this.userInfo.onlineData.genzaiYmd, 'YYYYMMDD')
        .subtract(2, 'months')
        .format('YYYY-MM-DD');
      this.juchuYmdT = moment(
        this.userInfo.onlineData.genzaiYmd,
        'YYYYMMDD'
      ).format('YYYY-MM-DD');
      this.search = '';
      this.kakuninFlg = false;
      this.selected = [];

      this.$store.dispatch('g040/resetData');
    },
    hide(reload = true) {
      this.show = false;
      this.$emit('hide', reload);
    },
    handleRireki(item: any) {
      let rirekiItem = {
        hatchuJigyoshoCd: item.hatchuJigyoshoCd,
        hatchuEntryYmd: item.hatchuEntryYmd,
        hatchuNo: item.hatchuNo,
        hatchuShuseiCount: item.hatchuShuseiCount,
      };
      this.childRirekiItem = rirekiItem;
      this.childRirekiShow = true;
    },
    handleRenraku(item: any) {
      let renrakuItem = {
        hatchuJigyoshoCd: item.hatchuJigyoshoCd,
        hatchuEntryYmd: item.hatchuEntryYmd,
        hatchuNo: item.hatchuNo,
        hatchuShuseiCount: item.hatchuShuseiCount,
        hatchuRenrakuJiko: item.hatchuRenrakuJiko,
      };
      this.shoriKb = ShoriKb.REFER;
      this.childShowRenrakuEntry = true;
      this.childRenrakuItem = renrakuItem;
    },
    handleInfo(item: any) {
      this.childHeaderInputItem = item;
      this.childHeaderInputShow = true;
      this.shoriKb = ShoriKb.REFER;
    },
    handleEdit(item: any) {
      this.childHeaderInputItem = item;
      this.childHeaderInputShow = true;
      this.shoriKb = ShoriKb.UPD;
    },
    handleOkMessage() {
      if (this.loadErr) {
        window.location.href = '/';
      }
      this.loadErr = false;
      this.messageId = '';
      this.messageTextParam = [];
      this.messageShow = false;

      if (this.messageConfirmSubmit) {
        this.messageConfirmSubmit = false;
        this.handleExecuteCsv();
      }
      if (this.isReload) {
        this.isReload = false;
        this.handleReset();
      }
    },
    handleExecute() {
      // ローディング・スタート
      this.$store.dispatch('common/setIsLoading', true);

      const data = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          targetInfo: this.selected.map((item: any) => {
            return {
              hatchuJigyoshoCd: item.hatchuJigyoshoCd,
              hatchuEntryYmd: dateStrToNum(item.hatchuEntryYmd),
              hatchuNo: item.hatchuNo,
              hatchuShuseiCount: item.hatchuShuseiCount,
              koshinCountHeader: item.koshinCountHeader,
              koshinCountDetailSum: item.koshinCountDetailSum,
              kojoJotaiKb: KojoJotaiKb.KAKUNIN,
            };
          }),
        },
      };

      this.$store.dispatch('g040/putHatchuConfirm', data).then((res: any) => {
        if (
          res &&
          res.status == 200 &&
          res.data &&
          res.data.error &&
          res.data.error.messageID &&
          res.data.error.outStatus &&
          res.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.messageShow = true;
          this.messageId = res.data.error.messageID;
          this.messageTextParam = res.data.error.messageArgs;
          if (res.data.error.outStatus === OutStatus.EXCLUSIVE_ERR) {
            this.handleReset();
          }
          if (res.data.error.outStatus === OutStatus.CHECK_ERR) {
            // do nothing
          }
          // ローディング・ストップ
          this.$store.dispatch('common/setIsLoading', false);

          return;
        }
        // ローディング・ストップ
        this.$store.dispatch('common/setIsLoading', false);
        // 再表示
        this.handleReset();
      });
    },
    async checkValidate() {
      if (!dateStrToNum(this.juchuYmdF) && !dateStrToNum(this.juchuYmdT)) {
        this.messageId = 'KI_W113';
        this.messageTextParam = ['検索条件'];
        this.messageShow = true;
        return;
      }
      if (
        this.juchuYmdF &&
        this.juchuYmdT &&
        dateStrToNum(this.juchuYmdF) > dateStrToNum(this.juchuYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['受注日'];
        this.messageShow = true;
        return;
      }
      return true;
    },
    async getData() {
      this.selected = [];
      this.$store.dispatch('common/setIsLoading', true);
      const params = {
        kyoryokuKojoCd: this.userInfo.shiiresakiCd,
        juchuYmdF: dateStrToNum(this.juchuYmdF),
        juchuYmdT: dateStrToNum(this.juchuYmdT),
      };
      const res = await this.$store.dispatch(
        'g040/getHatchuConfirmList',
        params
      );
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        this.messageShow = true;
        this.messageId = error.messageID;
        this.messageTextParam = error.messageArgs;
        this.isReload = false;
        return;
      }
    },
    handleChildRirekiShowHide() {
      this.childRirekiShow = false;
      this.childRirekiItem = {};
    },
    handleChildHeaderInputHide(reload: boolean) {
      this.childHeaderInputShow = false;
      this.childHeaderInput = {};
      if (reload) {
        this.handleReset();
      }
    },
    // 発注連絡事項を起動
    async handleRenrakuEntry() {
      this.showRenrakuEntry = true;
    },
    // 発注連絡事項を閉じる
    handleCloseRenrakuEntry() {
      this.showRenrakuEntry = false;
    },
    async handleDownloadHatchu(item: any) {
      const payload = {
        s3Url: item.hatchushoURL,
      };
      const response = await this.$store.dispatch('g040/downloadFile', payload);
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.error &&
        response.data.error.outStatus &&
        response.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.messageShow = true;
        if (response.data.error.messageID == 'KI_W107') {
          this.isReload = true;
          this.messageId = 'KI_W124';
        } else {
          this.messageId = response.data.error.messageID;
        }
        this.messageTextParam = response.data.error.messageArgs;
        return;
      }
    },
    handleExportCsv() {
      this.messageConfirmSubmit = true;
      this.messageId = 'KI_Q100';
      this.messageTextParam = ['CSVを出力して確認済に更新'];
      this.messageShow = true;
    },
    handleExecuteCsv() {
      const rows = [...[headerExportCSV]];

      const data = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          kyoryokuKojoCd: this.userInfo.shiiresakiCd,
          targetInfo: this.selected.map((item: any) => {
            return {
              hatchuJigyoshoCd: item.hatchuJigyoshoCd,
              hatchuEntryYmd: item.hatchuEntryYmd,
              hatchuNo: item.hatchuNo,
              hatchuShuseiCount: item.hatchuShuseiCount,
              rirekiNo: item.rirekiNo,
              koshinCountHeader: item.koshinCountHeader,
              koshinCountDetailSum: item.koshinCountDetailSum,
            };
          }),
        },
      };

      this.$store.dispatch('g040/getCsvData', data).then((res: any) => {
        if (
          res &&
          res.status == 200 &&
          res.data &&
          res.data.error &&
          res.data.error.outStatus &&
          res.data.error.outStatus != OutStatus.NORMAL
        ) {
          this.messageShow = true;
          this.messageId = res.data.error.messageID;
          this.messageTextParam = res.data.error.messageArgs;
          this.isBackEndError = true;
          return;
        } else {
          if (
            res.data.responseData.gaibuRenkeiKinoId ===
            GaibuRenkeiKinoId.HATCHU_CONFIRM
          ) {
            res.data.responseData.csvData.map((item: any) =>
              rows.push(getRow(item))
            );

            // ファイル名
            let fileAddStr = '';
            fileAddStr += '_' + moment(new Date()).format('YYYYMMDD_HHmmss');
            const fileName = `受注確認${fileAddStr}.csv`;

            // CSVダウンロード
            downloadCSVToSjis(rows, fileName);
          }
        }
        this.handleReset();
      });
    },
    async handleIkkatsuPreview() {
      //======================================
      // 発注書一括プレビューClick
      //======================================
      const payload = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          taishoInfo: this.selected.map((item: any) => {
            return {
              hatchuJigyoshoCd: item.hatchuJigyoshoCd,
              hatchuEntryYmd: item.hatchuEntryYmd,
              hatchuNo: item.hatchuNo,
              hatchuShuseiCount: item.hatchuShuseiCount,
              rirekiNo: item.rirekiNo,
              hatchuKakuteiYmd: item.hatchuKakuteiYmd,
            };
          }),
        },
      };
      const data = await this.$store.dispatch(
        'g040/putHatchushoIkkatsu',
        payload
      );
      if (
        data &&
        data.status == 200 &&
        data.data &&
        data.data.error &&
        data.data.error.outStatus &&
        data.data.error.outStatus != OutStatus.NORMAL
      ) {
        // errorの場合、自画面の再検索を行わない
        this.isReloadStopFlg = true;
        this.wMessageId = data.data.error.messageID;
        this.wMessageTextParam = data.data.error.messageArgs;
        this.wMessage = true;
        return;
      }

      this.exportType = '発注書';
      const reportResponse = await fetch(
        '/reports/N_Hat051_Hatchusho.rdlx-json'
      );
      this.exportDialogShow = true;
      const report = await reportResponse.json();
      report.DataSources[0].ConnectionProperties.ConnectString =
        'jsondata=' + JSON.stringify(data.data.responseData.hatchushoReportData);
      this.reportData = report;
      this.reportDataSet = await data;
      this.reportParameter = [
        { Name: 'dataString', Value: [JSON.stringify(data)] },
      ];
      if (this.$refs.reportViewer) {
        this.$refs.reportViewer
          .Viewer()
          .open(report, { ReportParams: this.reportParameter });
        // 帳票フォント定義
        const fonts: FontDescriptor[] = [
          {
            name: 'ＭＳ ゴシック',
            source: '/fonts/msgothic.ttc',
            postscriptName: 'MS-Gothic',
          },
          { name: 'IPAゴシック', source: '/fonts/ipag.ttf' },
        ];
        FontStore.registerFonts(...fonts);
      }      
    },
    async exportOrder() {
      //======================================
      // PDFダウンロードClick
      //======================================
      const date = new Date();
      const fileName = '発注書_'
                       + date.getFullYear()
                       + ('00' + (date.getMonth() + 1) ).slice(-2)
                       + ('00' + date.getDate()).slice(-2)
                       + '_'
                       + ('00' + date.getHours()).slice(-2)
                       + ('00' + date.getMinutes()).slice(-2)
                       + ('00' + date.getSeconds()).slice(-2);
      const title = fileName; 
      if (!title && !fileName) {
        console.log('不明なデータ');
        return;
      }

      const newReport = new PageReport({ language: 'jp' });
      const data = await this.reportDataSet;
      const doc = await newReport.load(this.reportData).then(() => {
        newReport.parameters['dataString'].values = [JSON.stringify(data)];
        return newReport.run();
      });
      PdfExport.exportDocument(doc, {
        info: {
          title,
        },
      })
        .then((result) => {
          result.download(fileName);
        })
        .catch(console.error);
    },
    async exportDialogClose() {
      //======================================
      // プレビュー画面Close
      //======================================
      this.exportDialogShow = false;

    },

  },
  created() {
    if (!this.userInfo.shiiresakiCd) {
      this.loadErr = true;
      this.messageId = 'KI_W123';
      this.messageTextParam = ['利用者マスタの仕入先が未設定の', '実行'];
      this.messageShow = true;
      return;
    }
    this.loadErr = false;
    this.handleClear();
  },
});
